import TranslationsSwitcher from "./translations-switcher";
export default TranslationsSwitcher;